import React from 'react'

import Pinterest from 'images/inline/social/pinterest.svg'
import Instagram from 'images/inline/social/instagram.svg'
import Facebook from 'images/inline/social/facebook.svg'
import x from 'images/inline/social/x.svg'

const socialMediaItems = [
  {
    name: 'Facebook',
    link: 'https://www.facebook.com/Dailybreak',
    Image: Facebook,
  },
  {
    name: 'X',
    link: 'https://x.com/takeadailybreak',
    Image: x,
  },
  {
    name: 'Instagram',
    link: 'https://instagram.com/takeadailybreak',
    Image: Instagram,
  },
  {
    name: 'Pinterest',
    link: 'https://www.pinterest.com/dailybreak/',
    Image: Pinterest,
  },
]
const SocialMediaSection = () => (
  <div className="footer__social">
    <ul className="social">
      {!!socialMediaItems.length &&
        socialMediaItems.map(item => {
          const { name, link, Image } = item
          return (
            <li key={name} className="social-item">
              <a
                className={`social-icon-${name}`}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                title={name}
              >
                <Image alt={name} />
              </a>
            </li>
          )
        })}
    </ul>
  </div>
)

export default SocialMediaSection
